import VerificationsPage from './VerificationsPage';

export default VerificationsPage;
